import { WSServiceError } from "../../../../utils/serviceHelper";
import { WSService } from "../../../../utils/WSService";
import { ListPayablesRequest, PayablesSummaryResponse } from "./types";

const service = new WSService("/v2/payments/payables");

export const getPayablesSummary = async (
  request: ListPayablesRequest
): Promise<PayablesSummaryResponse> => {
  try {
    const { headers } = await service.get("", {
      params: { ...request, "page[size]": 1 },
      headers: { "X-WS-Get-List-Summary": "true" }
    });

    return {
      listSize: Number(headers["x-ws-list-size"]),
      totalValue: headers["x-ws-custom-payable-amount-total"]
        ? Number(headers["x-ws-custom-payable-amount-total"])
        : undefined
    };
  } catch (err) {
    // TEMP: wingspan-api 500s on empty filter results until the @wingspanhq/grpc
    // empty-resultset fix (grpc#66) is released and adopted. Treat 500 as empty
    // so the UI is testable; remove once the grpc bump lands.
    if ((err as WSServiceError)?.response?.status === 500) {
      return { listSize: 0, totalValue: undefined };
    }
    throw err;
  }
};
